module.exports = __webpack_public_path__ + "static/media/  (92).69319c4c.jpg";